var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AxiosWrapper from '@gravity-ui/axios-wrapper';
import axiosRetry from 'axios-retry';
import { parseError } from './common';
// Symbols are not preserved in the Axios config
const csrfRetryKey = '__ CSRF retry';
export default class Api extends AxiosWrapper {
    constructor(_a = {}, handleRequestError) {
        var { updateCsrfEnabled } = _a, props = __rest(_a, ["updateCsrfEnabled"]);
        super(props);
        if (updateCsrfEnabled) {
            this._axios.interceptors.response.use(null, async (error) => {
                var _a;
                const { config } = error;
                if (config && !config[csrfRetryKey] && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 419) {
                    return this._axios(Object.assign(Object.assign({}, config), { [csrfRetryKey]: true }));
                }
                return Promise.reject(error);
            });
        }
        axiosRetry(this._axios, {
            retries: 0,
            retryDelay: axiosRetry.exponentialDelay,
            retryCondition: (error) => {
                if (!error.config) {
                    return false;
                }
                return axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error);
            },
        });
        if (typeof handleRequestError === 'function') {
            this.handleRequestError = handleRequestError;
        }
    }
    handleRequestError(errorResponse) {
        throw parseError(errorResponse);
    }
}
